import mapSceneToComponent from '../mapSceneToComponent.js'
import script from './openingScene.json'

export const Scene = (scene) => () => {
  return (
    <>
      {scene.map(mapSceneToComponent)}
    </>
  )
}

const scenes = script.scenes

const art = [
  { url: '/opening_scene/scene1.png' },
  { url: '/opening_scene/scene2.png' },
  { url: '/opening_scene/scene3.png' }
]

const stories = scenes.map((scene, i) => ({
  sceneArt: art[i],
  scene
}))

export default stories
